function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameClockTemplate = require('./game-clock.template');
var GameShotClockTemplate = require('./game-clock-shot.template');
var GameClock = /*#__PURE__*/function () {
  function GameClock(app, mod) {
    _classCallCheck(this, GameClock);
    this.app = app;
    this.game_mod = mod;
    this.container = '';
    this.clock_limit = 3600000; // maximum amount of time a player can have
    this.clock_timer = null; // For individual control of the clock
    this.useShotClock = false;
  }
  return _createClass(GameClock, [{
    key: "render",
    value: function render() {
      try {
        if (!document.querySelector('.game-clock')) {
          var html = this.useShotClock ? GameShotClockTemplate() : GameClockTemplate();
          if (this.container) {
            for (var i = 1; i <= this.game_mod.game.clock.length; i++) {
              var qs = this.container + i;
              this.app.browser.addElementToSelector(html, qs);
            }
          } else {
            this.app.browser.addElementToDom(html);
            this.attachEvents();
          }
        }

        //document.getElementById('game-clock').style.display = 'block';
      } catch (err) {}
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      try {
        document.querySelector('.game-clock').addEventListener('click', function (e) {
          _this.moveClock();
        });
      } catch (err) {}
    }
  }, {
    key: "returnHours",
    value: function returnHours(x) {
      if (x <= 0) {
        return 0;
      }
      return Math.floor(this.returnMinutes(x) / 60);
    }
  }, {
    key: "returnMinutes",
    value: function returnMinutes(x) {
      if (x <= 0) {
        return 0;
      }
      return Math.floor(this.returnSeconds(x) / 60);
    }
  }, {
    key: "returnSeconds",
    value: function returnSeconds(x) {
      if (x <= 0) {
        return 0;
      }
      return Math.floor(x / 1000);
    }
  }, {
    key: "startClock",
    value: function startClock(time) {
      var _this2 = this;
      var player = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      clearInterval(this.clock_timer); //Just in case
      this.clock_limit = time;
      this.render();
      var baseTime = new Date().getTime() + time;

      //Refresh the clock every second
      this.clock_timer = setInterval(function () {
        var currentTime = new Date().getTime();
        var timeLeft = baseTime - currentTime;
        if (timeLeft <= 0) {
          clearInterval(_this2.clock_timer);
          _this2.displayTime(0, player);
        }
        _this2.displayTime(timeLeft, player);
      }, 79);
    }
  }, {
    key: "stopClock",
    value: function stopClock() {
      var _this3 = this;
      clearInterval(this.clock_timer);
      setTimeout(function () {
        _this3.hide();
      }, 800);
    }
  }, {
    key: "displayTime",
    value: function displayTime(clock) {
      var player = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.show();
      var hours = this.returnHours(clock);
      var minutes = this.returnMinutes(clock);
      var seconds = this.returnSeconds(clock);
      var ms = clock % 1000;
      seconds = seconds - minutes * 60;
      minutes = minutes - hours * 60;
      if (hours < 0) {
        hours = 0;
      }
      if (minutes < 0) {
        minutes = 0;
      }
      if (seconds < 0) {
        seconds = 0;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      var qs = '';
      if (this.container && player) {
        qs = this.container + player + ' ';
      }
      if (document.querySelector(qs + '#game-clock-hours')) {
        document.querySelector(qs + '#game-clock-hours').innerHTML = hours;
      }
      if (document.querySelector(qs + '#game-clock-minutes')) {
        document.querySelector(qs + '#game-clock-minutes').innerHTML = minutes;
      }
      if (document.querySelector(qs + '#game-clock-seconds')) {
        document.querySelector(qs + '#game-clock-seconds').innerHTML = seconds;
      }
      if (document.querySelector(qs + '#game-clock-miliseconds')) {
        ms = ms.toString().padStart(3, '0');
        document.querySelector(qs + '#game-clock-miliseconds').innerHTML = ms;
      }
      if (document.querySelector(qs + '.game-clock')) {
        document.querySelector(qs + '.game-clock').style.color = this.analyzeTime(clock);
      }
    }
  }, {
    key: "analyzeTime",
    value: function analyzeTime(clock) {
      if (clock / this.clock_limit > 0.8) {
        return 'darkorange';
      }
      if (clock / this.clock_limit > 0.65) {
        return 'darkorange';
      }
      if (clock / this.clock_limit > 0.5) {
        return 'gold';
      }
      if (clock / this.clock_limit > 0.3) {
        return 'orange';
      }
      if (clock / this.clock_limit > 0.15) {
        return 'orangered';
      }
      return '';
    }
  }, {
    key: "moveClock",
    value: function moveClock() {
      var c = document.querySelector('.game-clock');
      if (c.style.top === '0px' || c.style.top == null || c.style.top === ' ' || c.style.top == '') {
        c.style.top = 'unset';
        c.style.bottom = '0px';
      } else {
        c.style.bottom = 'unset';
        c.style.top = '0px';
      }
    }
  }, {
    key: "show",
    value: function show() {
      var c = document.querySelectorAll('.game-clock');
      var _iterator = _createForOfIteratorHelper(c),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var clock = _step.value;
          clock.style.display = '';
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var c = document.querySelectorAll('.game-clock');
      var _iterator2 = _createForOfIteratorHelper(c),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var clock = _step2.value;
          clock.style.display = 'none';
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }]);
}();
/*
	Sample code for a shot-clock

	startClock() {
		if (!this.useClock || this.game.over) {
			return;
		}

		clearTimeout(this.clock_timer); //Just in case

		this.clock.startClock(this.game.clock_limit);

		//Refresh the clock every second
		this.clock_timer = setTimeout(() => {
			this.clock.displayTime(0);
			salert('Turn ended automatically');
			this.clearBoard();
			this.removeEvents();
			this.addMove('discard_tiles\t' + this.game.player + '\t');
			this.endTurn();
		}, this.game.clock_limit);
	}

	stopClock() {
		if (!this.useClock) {
			return;
		}
		clearTimeout(this.clock_timer);
		this.clock.stopClock();
	}*/
module.exports = GameClock;